export default __webpack_public_path__ + "static/media/ribbon.6ccd088a.svg";